<template>
  <div>
    <!-- <div v-if="loader" class="loader">
      <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div> -->

    <div class="card-chart">
      <div v-if="isLoading" class="loader card">
        <idx-skeleton width="300" height="40" radius="0" class="mt-2 mb-2" />
        <idx-skeleton width="150" height="40" radius="0" class="mt-2 mb-2" />
        <idx-skeleton width="100" height="40" radius="0" class="mt-2" />
      </div>
      <div v-else-if="existValue()">
        <highcharts :options="chartOptions"></highcharts>
      </div>
      <div class="graph" v-else-if="!existValue()">
        {{ this.$t('reports.npsBar.noData') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import idxSkeleton from '@/components/molecules/idx-skeleton';
import EventBus from '../../../../eventBus';

export default {
  name: 'HorizontalBar',
  components: {
    idxSkeleton,
  },
  data: () => ({
    chartOptions: null,
    loader: true,
    promoters: 0,
    passive: 0,
    detractors: 0,
    userAuth: null,
    charTitle: '',
    chartNoData: '',
    chartSeries: '',
    chartPromoters: '',
    chartPassives: '',
    chartDetrators: '',
    chartMax: 100,
    isLoading: true,
  }),
  watch: {
    percentilNps: async function watchPercentilNps() {
      await this.setParams();
      await this.renderBars([
        this.promoters > 0 ? this.promoters : 0,
        this.passive > 0 ? this.passive : 0,
        this.detractors > 0 ? this.detractors : 0,
      ]);
    },
    myMetric: function watchMyMetric() {
      this.changeLabel();
    },
    calendarDates: async function watchDates() {
      this.isLoading = true;
      await this.setParams();
      await this.renderBars([
        this.promoters > 0 ? this.promoters : 0,
        this.passive > 0 ? this.passive : 0,
        this.detractors > 0 ? this.detractors : 0,
      ]);
    },
  },
  computed: {
    ...mapState('dashboard', ['percentilNps']),
    ...mapState('actions', ['myActionId']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('authentication', ['userProfile']),
  },
  methods: {
    ...mapActions('dashboard', ['setPercentilByDate']),
    ...mapActions('calendar', ['setDefaultDates']),

    existValue() {
      if (
        this.chartOptions && this.chartOptions.series && this.chartOptions.series[0].data[0] === 0 &&
        this.chartOptions.series[0].data[1] === 0 &&
        this.chartOptions.series[0].data[2] === 0
      ) {
        return false;
      }
      return true;
    },

    async setParams() {
      const total =
        this.percentilNps.promoters +
        this.percentilNps.passive +
        this.percentilNps.detractors;

      this.promoters = await parseFloat(
        ((this.percentilNps.promoters / total) * 100).toFixed(1),
      );
      this.passive = await parseFloat(
        ((this.percentilNps.passive / total) * 100).toFixed(1),
      );
      this.detractors = await parseFloat(
        ((this.percentilNps.detractors / total) * 100).toFixed(1),
      );
    },
    handleClick(type) {
      type = type.toLowerCase();

      let customerGroup;

      if (
        this.myMetric === 'csat-1-5' ||
        this.myMetric === 'csat-1-5(media)' ||
        this.myMetric === 'ces-1-5' ||
        this.myMetric === '5-stars'
      ) {
        if (type === '4-5') {
          customerGroup = 'promoters';
        } else if (type === '3') {
          customerGroup = 'passives';
        } else {
          customerGroup = 'detractors';
        }
      } else if (type.search('promotores') + 1 || type === '9 e 10') {
        customerGroup = 'promoters';
      } else if (type.search('neutros') + 1 || type === '8 e 7' || type === '7 e 8') {
        customerGroup = 'passives';
      } else {
        customerGroup = 'detractors';
      }

      this.$router.push({
        name: 'Respostas',
        query: { profile: customerGroup },
      });
    },
    async renderBars(series) {
      let categories = [];
      if (this.myMetric.indexOf('nps') !== -1) {
        categories = [
          `${this.percentilNps.promoters}
            ${this.chartPromoters}`,
          `${this.percentilNps.passive}
            ${this.chartPassives}`,
          `${this.percentilNps.detractors}
            ${this.chartDetrators}`,
        ];
      } else {
        categories = [
          `${this.chartPromoters}`,
          `${this.chartPassives}`,
          `${this.chartDetrators}`,
        ];
      }
      this.chartOptions = {
        title: {
          text: this.charTitle,
          align: 'left',
          style: {
            color: '#5f6368',
          },
        },
        chart: {
          type: 'bar',
          height: 350,
          spacing: [25, 20, 25, 20],
          borderRadius: 4,
          borderColor: 'rgba(0, 0, 0, 0.09)',
          borderWidth: 0.7,
          style: {
            fontFamily:
              '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
            fontSize: '12px',
          },
        },
        xAxis: {
          categories,
          visible: true,
          labels: {},
        },
        yAxis: {
          gridLineWidth: 0,
          max: this.chartMax,
          title: {
            text: '',
          },
          stackLabels: {
            enabled: true,
            fontWeight: 'bold',
          },
        },
        legend: {
          enabled: false,
        },
        series: [
          {
            name: this.chartSeries,
            colorByPoint: true,
            data: series,
            cursor: 'pointer',
            point: {
              events: {
                click: (e) =>
                  this.userProfile.permissions.answers.menu
                    ? this.handleClick(e.point.category)
                    : '',
              },
            },
          },
        ],
        tooltip: {
          valueSuffix: '%',
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
              format: '{y}%',
            },
          },
          series: {
            groupPadding: 0,
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        colors: ['#4ce595', '#ecdb12', '#d62027'],
      };
    },
    changeLabel() {
      if (this.myMetric.indexOf('nps') !== -1) {
        this.charTitle = this.$t('reports.horizontalBar.chartTitle');
        this.chartNoData = this.$t('reports.horizontalBar.chartNoData');
        this.chartSeries = this.$t('reports.horizontalBar.chartSeries');
        this.chartPromoters = this.$t('reports.promoterLabel');
        this.chartPassives = this.$t('reports.neutralLabel');
        this.chartDetrators = this.$t('reports.detractorLabel');
        this.chartMax = 100;
      } else if (this.myMetric.indexOf('ces') !== -1) {
        this.charTitle = this.$t('reports.horizontalBar.cesChartTitle');
        this.chartNoData = this.$t('reports.horizontalBar.cesChartNoData');
        this.chartSeries = this.$t('reports.horizontalBar.ceschartSeries');
        this.chartPromoters = '4-5';
        this.chartPassives = '3';
        this.chartDetrators = '1-2';
        this.chartMax = 100;
      } else if (this.myMetric === 'csat-1-5') {
        this.charTitle = this.$t('reports.horizontalBar.csatChartTitle');
        this.chartNoData = this.$t('reports.horizontalBar.csatChartNoData');
        this.chartSeries = this.$t('reports.horizontalBar.csatchartSeries');
        this.chartPromoters = '4-5';
        this.chartPassives = '3';
        this.chartDetrators = '1-2';
        this.chartMax = 100;
      } else if (this.myMetric === 'csat-1-5(media)') {
        this.charTitle = this.$t('reports.horizontalBar.csatAverageChartTitle');
        this.chartNoData = this.$t('reports.horizontalBar.csatChartNoData');
        this.chartSeries = this.$t('reports.horizontalBar.csatchartSeries');
        this.chartPromoters = '4-5';
        this.chartPassives = '3';
        this.chartDetrators = '1-2';
        this.chartMax = 100;
      } else if (this.myMetric === 'csat-0-10(media)') {
        this.charTitle = this.$t(
          'reports.horizontalBar.csat0to10AverageChartTitle',
        );
        this.chartNoData = this.$t('reports.horizontalBar.csatChartNoData');
        this.chartSeries = this.$t('reports.horizontalBar.csatchartSeries');
        this.chartPromoters = this.$t('reports.horizontalBar.csatPromoters');
        this.chartPassives = this.$t('reports.horizontalBar.csatPassives');
        this.chartDetrators = '0-6';
        this.chartMax = 100;
      } else if (this.myMetric === '5-stars') {
        this.charTitle = this.$t('reports.horizontalBar.fiveStarsTitle');
        this.chartNoData = this.$t(
          'reports.horizontalBar.fiveStarsChartNoData',
        );
        this.chartSeries = this.$t(
          'reports.horizontalBar.fiveStarschartSeries',
        );
        this.chartPromoters = '4-5';
        this.chartPassives = '3';
        this.chartDetrators = '1-2';
        this.chartMax = 100;
      } else if (this.myMetric.indexOf('like-dislike') !== -1) {
        this.charTitle = this.$t('reports.horizontalBar.likeDislikeTitle');
        this.chartNoData = this.$t(
          'reports.horizontalBar.likeDislikeChartNoData',
        );
        this.chartSeries = this.$t(
          'reports.horizontalBar.likeDislikechartSeries',
        );
        this.chartPromoters = '1';
        this.chartPassives = '';
        this.chartDetrators = '0';
        this.chartMax = 100;
      }
    },
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
  async mounted() {
    this.changeLabel();
    EventBus.$on('refresh', async () => {
      await this.setParams();
      await this.renderBars([
        this.promoters > 0 ? this.promoters : 0,
        this.passive > 0 ? this.passive : 0,
        this.detractors > 0 ? this.detractors : 0,
      ]);
    });
    EventBus.$on('drawer', async (payload) => {
      if (payload) {
        await this.renderBars([
          this.promoters > 0 ? this.promoters : 0,
          this.passive > 0 ? this.passive : 0,
          this.detractors > 0 ? this.detractors : 0,
        ]);
      }
    });
    EventBus.$on('load-nps', () => {
      this.loader = false;
      this.isLoading = false;
    });
    EventBus.$on('apply-filter-menu', () => {
      this.isLoading = true;
    });
    EventBus.$on('reset-filter-menu', () => {
      this.isLoading = true;
    });
    if (this.promoters === 0 && this.passive === 0 && this.detractors === 0) {
      this.loader = false;
      this.chartOptions = {
        title: {
          text: this.chartNoData,
          align: 'left',
          style: {
            color: '#5f6368',
          },
        },
        chart: {
          type: 'bar',
          height: 350,
          spacing: [25, 20, 25, 20],
          borderRadius: 4,
          borderColor: 'rgba(0, 0, 0, 0.09)',
          borderWidth: 0.7,
          style: {
            fontFamily:
              '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
            fontSize: '12px',
          },
        },
      };
    }
  },
  beforeDestroy() {
    EventBus.$off('drawer');
    EventBus.$off('refresh');
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.graph {
  border: 1px solid rgba(0, 0, 0, 0.09);
  padding: 18px 0;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  border-radius: 4px;
  background-color: #fff;
  height: 350px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  padding: 20px;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/horizontal-bar/index.vue